export default function (notes, $state, toaster, close, $stateParams, deleteTag, addNote, tagSwitchService) {
    const vm = this;

    vm.model = {subject: '300'};
    vm.investigationTagId = 5;
    vm.form = null;
    vm.save = save;
    vm.closeModal = close;
    vm.investigationTagId = 5;

    function save() {
        if (vm.form.$invalid) {
            return;
        }

        vm.model.vehicleId = $stateParams.vehicleId;
        addNote(vm.model).then(returnData => {
            // Add the note to the model so that it becomes visible
            notes.push(returnData.data);
            deleteTag($stateParams.vehicleId, vm.investigationTagId).then(() => {
                toaster.pop('success', 'The investigation is closed successfully');
                // Set isUnderInvestigation = false
                tagSwitchService.publish('load-list');
                close();
            });
        })
        .catch(error => {
            toaster.pop('error', error.data);
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/investigations/close/closeInvestigationCtrl.js